var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M15.144,1.37H7.836c-0.252,0-0.492,0.105-0.663,0.291L2.744,6.476C2.592,6.642,2.507,6.859,2.507,7.085 v9.196c0,1.295,1.055,2.349,2.351,2.349h11.735c0.497,0,0.9-0.403,0.9-0.9V3.72C17.493,2.424,16.438,1.37,15.144,1.37z  M15.692,16.829H4.857c-0.304,0-0.551-0.245-0.551-0.548V7.819h2.156c1.156,0,2.027-0.872,2.027-2.027V3.17h6.653 c0.303,0,0.549,0.247,0.549,0.55V16.829z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
export default __webpack_public_path__ + "static/media/icon-note.55e13b8a.svg";
export { ForwardRef as ReactComponent };